import type { UseWalktourProps } from 'src/components/walktour/types';

import { Typography } from '@mui/material';

import { paths } from 'src/routes/paths';

export const dashboardWalktour: UseWalktourProps = {
  defaultRun: false,

  steps: [
    {
      // 0
      target: 'body',
      title: 'Eğitime Başla',
      content: 'Merhaba, şimdi size restoran yönetim panelinin nasıl kullanıldığını göstereceğim.',
      placement: 'center',
      hideCloseButton: true,
      stepPath: paths.dashboard.home,
    },
    {
      // 1
      target: '#dashboard-nav',
      title: 'Ana Sayfa',
      content:
        'Restoranınızın genel durumunu, raporlarınızı ve diğer bilgilerinizi burada görebilirsiniz.',
      placement: 'right',
      hideCloseButton: true,
      stepPath: paths.dashboard.home,
    },
    {
      // 2
      target: '#branches-nav',
      title: 'Şubeler',
      content: 'Şubelerinizin listesini buradan görebilirsiniz.',
      placement: 'right',
      navigationPath: paths.dashboard.branches.root,
      hideCloseButton: true,
      stepPath: paths.dashboard.home,
    },
    {
      // 3
      target: '#branches-table-container',
      title: 'Şube Tablosu',
      content: 'Oluşturulmuş şubelerinizin listesini burada görüntüleyebilirsiniz.',
      placement: 'bottom',
      hideCloseButton: true,
      stepPath: paths.dashboard.branches.root,
    },
    {
      // 4
      target: '#new-branch-button',
      title: 'Yeni Şube Oluşturmak',
      content: 'Yeni şube oluşturmak için buradan ilerleyebilirsiniz.',
      placement: 'left',
      navigationPath: paths.dashboard.branches.new,
      hideCloseButton: true,
      stepPath: paths.dashboard.branches.root,
    },
    {
      // 5
      target: '#branch-form-card',
      title: 'Şube Formunu Doldurun',
      content:
        'Lütfen şube adını girin ve formu gönderin. Form gönderildikten sonra otomatik olarak bir sonraki adıma geçeceğiz.',
      placement: 'top',
      waitForSubmit: true,
      submitFromPath: paths.dashboard.branches.new,
      submitToPath: paths.dashboard.branches.root,
      hideCloseButton: true,
      spotlightClicks: true,
      stepPath: paths.dashboard.branches.new,
    },
    {
      // 6
      target: '#branches-table-container',
      title: 'Şubeniz Başarıyla Oluşturuldu!',
      content:
        'Listede şubenizin detaylarını görebilirsiniz. Durum kısmı, şubenin açık/kapalı durumunu belirler, aktif olmayan şubeler menünüzde gözükmez. Satırın sonunda bulunan işlemler kısmından şubenizi düzenleyebilir veya silebilirsiniz.',
      placement: 'bottom',
      hideCloseButton: true,
      disableScrolling: true,
      disableScrollParentFix: true,
    },
    {
      // 7
      target: '#categories-nav',
      title: 'Kategoriler',
      content: 'Kategorilerinizin listesini buradan görebilirsiniz.',
      placement: 'right',
      navigationPath: paths.dashboard.categories.root,
      hideCloseButton: true,
      stepPath: paths.dashboard.branches.root,
    },
    {
      // 8
      target: '#categories-table-container',
      title: 'Kategori Tablosu',
      content: 'Oluşturulmuş kategorilerinizin listesini burada görüntüleyebilirsiniz.',
      placement: 'bottom',
      hideCloseButton: true,
      stepPath: paths.dashboard.categories.root,
    },
    {
      // 9
      target: '#new-category-button',
      title: 'Yeni Kategori Oluşturmak',
      content: 'Yeni kategori oluşturmak için buradan ilerleyebilirsiniz.',
      placement: 'left',
      navigationPath: paths.dashboard.categories.new,
      hideCloseButton: true,
      stepPath: paths.dashboard.categories.root,
    },
    {
      // 10
      target: '#category-form-card',
      title: 'Kategori Formunu Doldurun',
      content:
        'Lütfen kategori adını girin, şubeleri seçin ve formu gönderin. Form gönderildikten sonra otomatik olarak bir sonraki adıma geçeceğiz.',
      placement: 'top',
      waitForSubmit: true,
      submitFromPath: paths.dashboard.categories.new,
      submitToPath: paths.dashboard.categories.root,
      hideCloseButton: true,
      spotlightClicks: true,
      stepPath: paths.dashboard.categories.new,
    },
    {
      // 11
      target: '#categories-table-container',
      title: 'Kategoriniz Başarıyla Oluşturuldu!',
      content:
        'Listede kategorinizin detaylarını görebilirsiniz. Durum kısmı, kategorinin açık/kapalı durumunu belirler, aktif olmayan kategoriler menünüzde gözükmez. Satırın sonunda bulunan işlemler kısmından kategorinizi düzenleyebilir veya silebilirsiniz.',
      placement: 'bottom',
      hideCloseButton: true,
      disableScrolling: true,
      disableScrollParentFix: true,
      stepPath: paths.dashboard.categories.root,
    },
    {
      // 12
      target: '#products-nav',
      title: 'Ürünler',
      content: 'Ürünlerinizin listesini buradan görebilirsiniz.',
      placement: 'right',
      navigationPath: paths.dashboard.product.list,
      hideCloseButton: true,
      stepPath: paths.dashboard.categories.root,
    },
    {
      // 13
      target: '#products-table-container',
      title: 'Ürün Tablosu',
      content:
        'Oluşturulmuş ürünlerinizin listesini burada görüntüleyebilirsiniz. Ürünler ve yan ürünler arasında geçiş yapabilirsiniz.',
      placement: 'bottom',
      hideCloseButton: true,
      stepPath: paths.dashboard.product.list,
    },
    {
      // 14
      target: '#new-product-button',
      title: 'Yeni Ürün Oluşturmak',
      content: 'Yeni ürün oluşturmak için buradan ilerleyebilirsiniz.',
      placement: 'left',
      navigationPath: paths.dashboard.product.new,
      hideCloseButton: true,
      stepPath: paths.dashboard.product.list,
    },
    {
      // 15
      target: '#product-images-container',
      title: 'Ürün Görsellerini Yükleyin (Opsiyonel)',
      content: (
        <Typography>
          Ürün görsellerini seçmek için buraya tıklayabilirsiniz.
          <br />
          <br />
          Görselleri seçtikten sonra{' '}
          <Typography fontWeight="800" component="span">
            Yükle
          </Typography>{' '}
          tuşuna basarak görsellerinizi yükleyebilirsiniz. Aksi takdirde görsel{' '}
          <Typography fontWeight="800" component="span">
            yüklenmeyecektir.
          </Typography>
        </Typography>
      ),
      placement: 'right',
      hideCloseButton: true,
      spotlightClicks: true,
      stepPath: paths.dashboard.product.new,
    },
    {
      // 15
      target: '#product-form-card',
      title: 'Ürün Formunu Doldurun',
      content:
        'Lütfen ürün bilgilerini girin, kategorileri seçin ve formu gönderin. Form gönderildikten sonra otomatik olarak bir sonraki adıma geçeceğiz.',
      placement: 'left',
      waitForSubmit: true,
      submitFromPath: paths.dashboard.product.new,
      submitToPath: paths.dashboard.product.list,
      hideCloseButton: true,
      spotlightClicks: true,
      stepPath: paths.dashboard.product.new,
    },
    {
      // 16
      target: '#products-table-container',
      title: 'Ürününüz Başarıyla Oluşturuldu!',
      content:
        'Listede ürününüzün detaylarını görebilirsiniz. Durum kısmı, ürünün açık/kapalı durumunu belirler, aktif olmayan ürünler menünüzde gözükmez. Satırın sonunda bulunan işlemler kısmından ürününüzü düzenleyebilir veya silebilirsiniz.',
      placement: 'bottom',
      hideCloseButton: true,
      disableScrolling: true,
      disableScrollParentFix: true,
      stepPath: paths.dashboard.product.list,
    },
  ],
};
